import Vue from 'vue'
import App from './App.vue'
import router from './router'
import { store } from './store'

import Ionic from '@ionic/vue';
import '@ionic/core/css/core.css';
import '@ionic/core/css/ionic.bundle.css';

import VueCookie from 'vue-cookie';
import VueCookies from "vue-cookies";
import VuePlyr from 'vue-plyr';
import VueAnalytics from 'vue-analytics';
import VueCarousel from 'vue-carousel';
import Toasted from 'vue-toasted';
import VueTheMask from 'vue-the-mask';
import MobileAudio from './mobile-audio';
import MobileCourse from './mobile-course';
import VueImg from 'v-img';
import VModal from 'vue-js-modal/dist/ssr.nocss'
import './css/popup.css';

import lightgallery from 'lightgallery.js'
import 'lightgallery.js/dist/css/lightgallery.min.css'
import 'lg-zoom.js'

Vue.use(Ionic);
Vue.use(VueCookie);
Vue.use(VueCookies);
Vue.use(VuePlyr);
Vue.use(VueCarousel);
Vue.use(Toasted);
Vue.use(VueTheMask);
Vue.use(MobileAudio)
Vue.use(MobileCourse)
Vue.use(lightgallery)

Vue.use(VueImg, {
    altAsTitle: true,
    sourceButton: false,
    thumbnails: true,
});

Vue.use(VueAnalytics, {
    id: 'UA-150928281-1',
    router
});

Vue.use(VModal, {
    dialog: true,
    dynamic: true,
    injectModalsContainer: true,
    dynamicDefaults: {
        foo: 'foo'
    }
});

Vue.config.productionTip = false;

new Vue({
    router,
    store,
    render: h => h(App)
}).$mount('#app');
